import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-processed-po-key-dialog',
  templateUrl: './processed-po-key-dialog.component.html',
  styleUrls: ['./processed-po-key-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessedPoKeyDialogComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
